import GhostGuidePage from './features/Guides/GhostGuidePage';
import { comparisons } from './features/Compare/founderComparisonContent';
import ClubComparisonPage, { ComparisonIndexPage } from './features/Compare/ClubComparisonPage';
import TestClubPage from './features/TestClub/TestClubPage';
import ClubOutreachPage from './features/ClubOutreach/ClubOutreachPage';
import SportsClubAppPage from './features/SportsClubApp/SportsClubAppPage';
import SportsClubManagementPage from './features/SportsClubApp/SportsClubManagementPage';
import App from './App.jsx';
import AttendanceRegisterPage from './features/Guides/AttendanceRegisterPage';
import MembershipFormPage from './features/Guides/MembershipFormPage';
import ErrorPage from './features/Error/Error';
import HomePage from './features/Home/HomePage';
import FAQPage from './features/FAQs/FAQPage';
import FeaturesPage from './features/Features/FeaturesPage';
import PegboardPage from './features/PegBoard/PegboardPage';
import PricingPage from './features/Pricing/PricingPage';
import PrivacyPage from './features/Privacy';
import TermsPage from './features/Terms';
import BlogsPage from './features/Blog/Blog';
import ToursPage from './features/Tours.jsx';
import CalculatorPage from './features/Calculator';
import BadmintonClubPaymentPage from './features/Payments/BadmintonClubPaymentPage';
import AboutPage from './features/About/AboutPage';

const routes = [
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/compare', element: <ComparisonIndexPage /> },
      ...comparisons.map(({ slug }) => ({ path: `/compare/${slug}-alternative`, element: <ClubComparisonPage slug={slug} /> })),
      { path: '/your-club', element: <ClubOutreachPage />, errorElement: <ErrorPage /> },
      { path: '/sports-club-app', element: <SportsClubAppPage />, errorElement: <ErrorPage /> },
      { path: '/sports-club-management-software', element: <SportsClubManagementPage />, errorElement: <ErrorPage /> },
      { path: '/guides/club-attendance-register', element: <AttendanceRegisterPage />, errorElement: <ErrorPage /> },
      { path: '/guides/badminton-club-membership-form', element: <MembershipFormPage />, errorElement: <ErrorPage /> },
      { path: '/guides/switch-from-playwaze', element: <GhostGuidePage />, errorElement: <ErrorPage /> },
      { path: '/guides/switch-from-spond', element: <GhostGuidePage />, errorElement: <ErrorPage /> },
      { path: '/test-club', element: <TestClubPage />, errorElement: <ErrorPage /> },
      { path: '/guides/badminton-pegboard', element: <GhostGuidePage />, errorElement: <ErrorPage /> },
      { path: '/guides/switch-from-justgo-to-shuttleops', element: <GhostGuidePage />, errorElement: <ErrorPage /> },
      { path: '/', element: <HomePage />, errorElement: <ErrorPage /> },
      { path: '/faq', element: <FAQPage />, errorElement: <ErrorPage /> },
      { path: '/features/:persona', element: <FeaturesPage />, errorElement: <ErrorPage /> },
      { path: '/pegboard', element: <PegboardPage />, errorElement: <ErrorPage /> },
      { path: '/pricing', element: <PricingPage />, errorElement: <ErrorPage /> },
      { path: '/privacy', element: <PrivacyPage />, errorElement: <ErrorPage /> },
      { path: '/terms', element: <TermsPage />, errorElement: <ErrorPage /> },
      { path: '/tours', element: <ToursPage />, errorElement: <ErrorPage /> },
      { path: '/pulse', element: <BlogsPage />, errorElement: <ErrorPage /> },
      { path: '/pulse/:slug', element: <BlogsPage />, errorElement: <ErrorPage /> },
      { path: '/calculator', element: <CalculatorPage />, errorElement: <ErrorPage /> },
      { path: '/badminton-club-payment-software', element: <BadmintonClubPaymentPage />, errorElement: <ErrorPage /> },
      { path: '/about', element: <AboutPage />, errorElement: <ErrorPage /> },
      { path: '/guides/first-club-session', element: <GhostGuidePage />, errorElement: <ErrorPage /> },
      { path: '/guides/badminton-club-management-software', element: <GhostGuidePage />, errorElement: <ErrorPage /> },
      { path: '/guides/collect-badminton-club-payments', element: <GhostGuidePage />, errorElement: <ErrorPage /> },
    ],
  },
];

export default routes;
